import styled from 'styled-components';
import { motion } from 'framer-motion';

export const FeatureTitle = styled.h2`
	text-align: center;
	font-size: clamp(1.3rem, 13vw, 3.1rem);
	line-height: 1.06;
	letter-spacing: 0.4rem;
	margin: auto;
	color: #066a67;
	@media screen and (max-width: 768px) {
		font-size: clamp(0.8rem, 16vw, 2rem);
	}
`;

export const FeatureTextWrapper = styled.div`
	position: relative;
	padding: 0 0 20px;
	margin-bottom: 4rem;
`;

export const FeatureWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	margin-top: 4rem;
	grid-gap: 1.5rem;
	
	@media screen and (max-width: 1200px) {
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 1.5rem;
		margin-top: 3rem;
	}
	
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 1rem;
		margin-top: 2rem;
	}
	
	@media screen and (max-width: 568px) {
		grid-template-columns: repeat(1, 1fr);
		grid-gap: 1rem;
		margin-top: 2rem;
	}
`;

export const FeatureColumn = styled(motion.div)`
	text-decoration: none;
	display: flex;
	flex-direction: column;
	background: white;
	border-radius: 15px;
	overflow: hidden;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	cursor: pointer;
	
	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
	}
	
	@media screen and (max-width: 768px) {
		border-radius: 12px;
	}
`;

export const FeatureImageWrapper = styled.div`
	height: 160px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.3s ease;
	}
	
	&:hover img {
		transform: scale(1.05);
	}
	
	@media screen and (max-width: 768px) {
		height: 140px;
	}
	
	@media screen and (max-width: 480px) {
		height: 120px;
	}
`;

export const FeatureName = styled.h3`
	color: #066a67;
	font-weight: 700;
	font-size: 1.2rem;
	text-align: center;
	margin: 1.2rem 0.8rem 0.8rem 0.8rem;
	line-height: 1.3;
	
	@media screen and (max-width: 768px) {
		font-size: 1.1rem;
		margin: 1rem 0.6rem 0.6rem 0.6rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 1rem;
		margin: 0.8rem 0.5rem 0.5rem 0.5rem;
	}
`;

export const FeatureText = styled.p`
	color: #7f8c8d;
	font-size: 0.85rem;
	line-height: 1.5;
	text-align: center;
	margin: 0 0.8rem 1.2rem 0.8rem;
	flex-grow: 1;
	
	@media screen and (max-width: 768px) {
		font-size: 0.8rem;
		margin: 0 0.6rem 1rem 0.6rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 0.75rem;
		margin: 0 0.5rem 0.8rem 0.5rem;
	}
`;

export const ReadMoreButton = styled.div`
	color: #18776a;
	font-size: 0.8rem;
	font-weight: 600;
	text-align: center;
	margin: 0 0.8rem 1.2rem 0.8rem;
	text-decoration: underline;
	transition: color 0.3s ease;
	
	&:hover {
		color: #066a67;
	}
	
	@media screen and (max-width: 768px) {
		font-size: 0.75rem;
		margin: 0 0.6rem 1rem 0.6rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: 0.7rem;
		margin: 0 0.5rem 0.8rem 0.5rem;
	}
`;